/** 产品品牌（展示用；登录单位关键字仍可能是平台 shortName，如 FAMS） */
export const BRAND = {
  name: '灵犀资产 · FAMS',
  nameZh: '灵犀资产',
  nameEn: 'FAMS',
  product: '固定资产管理系统',
  tagline: 'AI 建档 · RFID 盘点 · 国标分类',
  fullTitle: '灵犀资产 · FAMS 固定资产管理系统'
}
